import { getAPI } from "../../api"
import {REACT_APP_JOBFILTER } from "../../utils/common"

export async function getAppliedCandidate(jobId: string , providerId: string){
    const Details = getAPI( REACT_APP_JOBFILTER + `/provider-applied-positions/${jobId}?providerId=${providerId}`)
    return Details
}